import React, { FC, useEffect, useState } from "react";
import { Collapse, Modal, Spin } from "antd";

import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";
import './vitals.scss'
import { cloneDeep } from "lodash";
import { VitalsProvider, useVitalsContext, Vital as VitalType } from './useVitals'

import { Vital } from './vital'

import { Edit as EditWeight } from './weight/edit/'
import { Chart } from "./chart";

import { chain } from "lodash"
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

import { formatDisplayDate } from "@utils/helpers";
import { useVitalsStore } from "@stores/vitalsStore";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";

const { Panel } = Collapse;

const Vitals: FC<any> = (props) => {
  const {
    vitalLoader,
    vitals,
    editPopup,
    graphPopup,
    refresh
  } = useVitalsContext()

  return (
    <div className="ui-vitals">
      {vitalLoader ? (
        <Spin spinning={vitalLoader} indicator={<HealthemSpinner size={50} />}></Spin>
      ) : (!vitals || !vitals.length) && !vitalLoader ? (
        <DataNotFound message={NO_DATA_FOUND} />
      ) : (
        <>
          <div className="ui-vitals__list">
            {vitals &&
              vitals.map((vital: any, index) => {
                return (
                  <div key={index} className="ui-vitals__list__item">
                    <Vital
                      vital={vital as VitalType}
                      onEdit={() => {
                        editPopup?.open(vital.actualName);
                      }}
                      onShowGraph={() => {
                        graphPopup?.open(vital.actualName);
                      }}
                    />
                  </div>
                );
              })}
          </div>
          <div className="ui-vitals__modals">
            <Modal onCancel={(e) => editPopup?.close()} wrapClassName="ui-vitals__modals__edit" visible={editPopup?.isOpen} width={"max-content"} destroyOnClose>
              {editPopup?.vital === "weight" && (
                <EditWeight
                  close={(shouldRefresh: boolean) => {
                    editPopup?.close && editPopup?.close();
                    if (shouldRefresh) {
                      refresh && refresh(['1']);
                    }
                  }}
                />
              )}
            </Modal>
            <Modal onCancel={(e) => graphPopup?.close()} wrapClassName="ui-vitals__modals__graph" visible={graphPopup?.isOpen} width={"50vw"} destroyOnClose>
              <Chart
                close={graphPopup?.close}
                name={graphPopup?.vital}
                vitalsOptions={chain(vitals)
                  .filter((v) => v.haveGraph)
                  .map((v) => {
                    let options: any = {
                      vital: v,
                      actualName: v.actualName,
                    };

                    if (v?.actualName?.includes("bp")) {
                      options.formatChartData = (data: any[]) => {
                        return data;
                      };

                      options.chartProps = (chartProps: any, unit: string) => {
                        return {
                          ...chartProps,
                          series: [
                            {
                              name: "Systolic",
                              data: chartProps.series.map((datum: any) => datum.systolicValue),
                            },
                            {
                              name: "Diastolic",
                              data: chartProps.series.map((datum: any) => datum.diastolicValue),
                            },
                          ],
                          options: {
                            ...chartProps.options,
                            xaxis: {
                              categories: chartProps.series.map((datum: any) => formatDisplayDate(datum.refreshDate, "createDateFormat")),
                            },
                            tooltip: {
                              ...chartProps.tooltip,
                              y: [
                                {
                                  formatter: (value: number, opts?: any) => {
                                    return `${value} ${unit}`;
                                  },
                                },
                                {
                                  formatter: (value: number, opts?: any) => {
                                    return `${value} ${unit}`;
                                  },
                                },
                              ],
                            },
                          },
                        };
                      };
                    }
                    return options;
                  })
                  .keyBy("actualName")
                  .value()}
              />
            </Modal>
          </div>
        </>
      )}
    </div>
  );
}

const View: FC<any> = (props) => {
  const defaultDataCardId = "2";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(defaultDataCardId) ? ["1"] : [])
  
  const {
    vitals,
    refresh,
    patientID,
    patientId,
  } = useVitalsContext()

  useEffect(()=> {
    setActiveCardPanel(props?.activeKey?.includes(defaultDataCardId) ? ["1"] : []);
    if((!vitals && props?.activeKey?.includes(defaultDataCardId)) || (patientID !== patientId)) {
      refresh && refresh(['1']);
    }
  }, [props?.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== defaultDataCardId))
    }
    else {
      if(!vitals) {
        refresh && refresh(['1']);
      }
      props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), defaultDataCardId]);
    };
  }

  const genExtra = (id: any) =>
  <PinUnpin marginRight={"16px"} dataCardId={id}
  changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds} />;

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "7px 8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <>
      <Collapse
        accordion
        activeKey={activeCardPanel}
        expandIconPosition="right"
        bordered={false}
        onChange={onCollapseChange}
      >
        <Panel
          header={getHeading("Vitals")}
          key="1"
          className="title"
          extra={genExtra(defaultDataCardId)}
          style={{marginBottom:"8px"}}
        >
          <Vitals />
        </Panel>
      </Collapse>
    </>
  );
};

const Wrapper: React.FC<any> = function (props) {
  return (
    <VitalsProvider >
      <View {...props} />
    </VitalsProvider>
  )
};

export default Wrapper
